import { Radio, FormControlLabel, Box } from '@mui/material';
import { FieldValue } from '../../../../../types/QueryBuilder';

interface RadioEditorProps {
    ruleId: string;
    value: string;
    values: FieldValue[];
    onChange: (value: string) => void;
}

function RadioEditor({ ruleId, value, values, onChange }: RadioEditorProps) {
    return (
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
            {values.map((option, idx) => (
                <FormControlLabel
                    key={`${ruleId}-radio-${idx}`}
                    control={
                        <Radio
                            checked={value === option.name}
                            onChange={(e) => onChange(e.target.value)}
                            value={option.name}
                            size="small"
                        />
                    }
                    label={option.label}
                />
            ))}
        </Box>
    );
};

export default RadioEditor;
